import { useQuery } from '@tanstack/react-query';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';
import { getInvestmentProgrammeByDealId } from '@dealstack/frontend/app/services/InvestmentProgramme.service.ts';

export const useMipsByDealId = (dealId: string) => {
	return useQuery({
		queryKey: [API_PATHS.MIP_GET, dealId],
		queryFn: () => getInvestmentProgrammeByDealId(API_PATHS.MIP_GET),
		enabled: !!dealId,
	});
};
